import { UpdateVideoDto } from '@greco/videos';
import { Type } from 'class-transformer';
import { IsDate, IsOptional } from 'class-validator';

export class UpdateCommunityVideoDto extends UpdateVideoDto {
  @IsDate()
  @IsOptional()
  @Type(() => Date)
  availableUntil?: Date | null;
}
